import React from "react";
import { Star } from "lucide-react";

/**
 * Star rating component. Two modes:
 *  - Display: pass `value` only
 *  - Input: pass `value` + `onChange`
 *
 * Sizes: sm | md | lg
 */
const StarRating = ({ value = 0, onChange = null, size = "md", count = 5, showValue = false, className = "" }) => {
  const sizes = { sm: 12, md: 16, lg: 22 };
  const px = sizes[size] || sizes.md;
  const isInput = typeof onChange === "function";

  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} data-testid="star-rating">
      {Array.from({ length: count }, (_, i) => {
        const idx = i + 1;
        const filled = value >= idx;
        const half = !filled && value >= idx - 0.5;
        const fill = filled ? "#D4AF37" : half ? "url(#half-gold)" : "transparent";
        return (
          <button
            key={i}
            type="button"
            disabled={!isInput}
            onClick={() => isInput && onChange(idx)}
            className={`p-0 leading-none ${isInput ? "cursor-pointer hover:scale-110 transition-transform" : "cursor-default"}`}
            aria-label={`${idx} star`}
            data-testid={`star-${idx}`}
          >
            <svg width={px} height={px} viewBox="0 0 24 24" fill={fill} stroke="#D4AF37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              {half && (
                <defs>
                  <linearGradient id="half-gold">
                    <stop offset="50%" stopColor="#D4AF37" />
                    <stop offset="50%" stopColor="transparent" />
                  </linearGradient>
                </defs>
              )}
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
            </svg>
          </button>
        );
      })}
      {showValue && value > 0 && (
        <span className="ml-2 text-xs text-[#736B66]">{Number(value).toFixed(1)}</span>
      )}
    </div>
  );
};

export default StarRating;
